import emailjs from '@emailjs/browser';

export interface EmailConfig {
  serviceId: string;
  templateId: string;
  publicKey: string;
}

export interface EmailParams {
  to_email: string;
  subject: string;
  message: string;
  title?: string;
  type?: string;
  [key: string]: any;
}

export const sendEmail = async (config: EmailConfig, params: EmailParams) => {
  if (!config.serviceId || !config.templateId || !config.publicKey) {
    throw new Error('Configuração de e-mail incompleta. Verifique as configurações em "Notificações & Alertas".');
  }

  try {
    const response = await emailjs.send(
      config.serviceId,
      config.templateId,
      params,
      config.publicKey
    );
    console.log('EmailJS Success:', response.status, response.text);
    return response;
  } catch (error) {
    console.error('Erro ao enviar e-mail:', error);
    throw error;
  }
};

export const sendTestEmail = async (config: EmailConfig, recipientEmail: string) => {
  return sendEmail(config, {
    to_email: recipientEmail,
    subject: 'Teste de Configuração - Ultra Licitação',
    message: 'Este é um e-mail de teste para confirmar que suas configurações do EmailJS estão corretas.',
    title: 'Teste de Sistema',
    type: 'TESTE'
  });
};
